// Documents go through the frontend's nginx rather than straight to the CDN,
// which forces html to download instead of opening. See client/nginx.conf.
// Only in production — locally there is no nginx, and Strapi's own uploader
// already serves files inline.
export const generateDocumentURL = (url) => {
  if (url) {
    return process.env.REACT_APP_PRODUCTION === 'true'
      ? `/files${new URL(url).pathname}`
      : `${process.env.REACT_APP_BASE_API_URL}${url}`;
  } else {
    return null;
  }
};
